module.exports = __webpack_public_path__ + "img/1795.ce17c209.jpg";